export const UNEMPLOYMENT_DURATION_MIN = 0;
export const UNEMPLOYMENT_DURATION_MAX = 1000;
export const AGE_MIN = 18;
export const AGE_MAX = 99;
